import $ from "jquery";

(() => {
    const menuShrinker = {
        $document: null,
        $window: null,
        $headerFixed: null,
        $submenu: null,
        lastScrollTop: null,
        delta: null,
        $shrinkingElement: null,
        init() {
            this.$document = $(document);
            this.$window = $(window);
            this.$headerFixed = $(".lux-header");
            this.$body = $("body");
            this.$submenu = $(".lux-main-menu-overlay");
            this.lastScrollTop = 0;
            this.delta = 100;
            this.$shrinkingElement = $("header .shrinking-element");
            this.shrinkListenerBinder("on");
        },
        shrink() {
            const _this = window.menuShrinker;

            if (!_this.$headerFixed.hasClass("collapsed")) {
                _this.$headerFixed.addClass("collapsed");

                if ($(window).width() < 1007) {
                    _this.$shrinkingElement.slideUp();
                }
            }
        },
        unShrink() {
            const _this = window.menuShrinker;

            if (_this.$headerFixed.hasClass("collapsed")) {
                _this.$headerFixed.removeClass("collapsed");

                if ($(window).width() < 1007) {
                    _this.$shrinkingElement.slideDown();
                }
            }
        },
        shrinkListener() {
            const _this = window.menuShrinker;
            const scrollTop = _this.$document.scrollTop();

            if (Math.abs(_this.lastScrollTop - scrollTop) >= _this.delta) {
                if (scrollTop > _this.lastScrollTop) {
                    _this.shrink();
                } else {
                    _this.unShrink();
                }
                _this.lastScrollTop = scrollTop;
            }
        },
        shrinkListenerBinder(act) {
            const doAct = act === "on" ? "on" : "off";
            this.$document[doAct]("scroll", this.shrinkListener);
            this.$document[doAct]("resize", this.unShrink);

            this.$headerFixed[doAct]("a input button").on(
                "focus",
                this.unShrink,
            );
        },
    };

    menuShrinker.init();

    window.menuShrinker = menuShrinker;
})();
